import { trpc } from '@/shared/api';

/** 저장마다 새 버전, 이동마다 새 커서이므로 전송 실패를 자동 재시도하지 않는다. */
export const useEditAreaMutations = () => {
  const save = trpc.editor.editAreas.save.useMutation({ retry: false });
  const undo = trpc.editor.editAreas.undo.useMutation({ retry: false });
  const redo = trpc.editor.editAreas.redo.useMutation({ retry: false });
  return { save: save.mutateAsync, undo: undo.mutateAsync, redo: redo.mutateAsync };
};
